export const fontSize = {
	xs: '0.75rem', // 12px
	sm: '0.875rem', // 14px
	md: '1rem', // 16px
	lg: '1.25rem', // 20px
	xl: '2.25rem', // 36px
} as const;
